import { z } from 'zod';
import { PedagogicContentState } from '@sphere/shared/domain';

/**
 * Schéma pour la création/édition d'un enseignement
 * Aligné avec le backend: tous les IDs sont des UUIDs (strings)
 */
export const teachingSchema = z
  .object({
    // Champs requis (UUIDs)
    establishmentId: z
      .string()
      .uuid('ID de l\'établissement invalide')
      .min(1, 'Veuillez sélectionner un établissement'),

    subjectExternalId: z
      .string({
        error: 'Veuillez sélectionner une matière',
      })
      .uuid('Veuillez sélectionner une matière valide')
      .min(1, 'Veuillez sélectionner une matière'),

    // typeId dérivé de la matière côté backend, pas saisi manuellement

    schoolYearId: z
      .string({
        error: 'Veuillez sélectionner une année scolaire',
      })
      .uuid('Veuillez sélectionner une année scolaire valide')
      .min(1, 'Veuillez sélectionner une année scolaire'),

    // Champs optionnels (UUIDs)
    classId: z
      .string()
      .uuid('ID de classe invalide')
      .optional()
      .or(z.literal('')),

    groupId: z
      .string()
      .uuid('ID de groupe invalide')
      .optional()
      .or(z.literal('')),

    specialtyRefId: z
      .string()
      .uuid('ID de spécialité invalide')
      .optional()
      .or(z.literal('')),

    programVersionId: z
      .string({
        error: 'Veuillez sélectionner un programme',
      })
      .uuid('ID de programme invalide')
      .min(1, 'Veuillez sélectionner un programme'),

    // Autres champs
    state: z.nativeEnum(PedagogicContentState),

    description: z.string().optional().or(z.literal('')),

    weightInProgression: z
      .number({
        error: 'Le poids doit être un nombre valide',
      })
      .min(1, 'Le poids doit être au moins 1')
      .max(100, 'Le poids ne peut pas dépasser 100')
      .optional(),

    estimatedWorkload: z
      .number({
        error: 'Le volume horaire doit être un nombre valide',
      })
      .min(0, 'Le volume horaire doit être un nombre positif')
      .max(999, 'Le volume horaire ne peut pas dépasser 999 heures')
      .optional(),
   
  })
  .refine((data) => data.classId || data.groupId, {
    message: 'Au moins une classe ou un groupe doit être sélectionné',
    path: ['classId'],
  });

export type TeachingFormData = z.infer<typeof teachingSchema> & {
  state: PedagogicContentState;
};
